import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';

import * as actions from '@actions/entities';
import { listEntities, createEntity, modifyEntity, deleteEntity } from '@api/entities';
import types from '@constants/action-types';
import { handleRequest } from '@sagas/request';

export const handleEntitiesListRequest = function* ({ payload: { limit, offset, ids, paged } }) {
  try {
    const response = yield call(listEntities, { limit, offset, ids, paged });
    if (response) {
      yield put(actions.entitiesListSuccess(response, paged));
    }
  } catch (error) {
    yield put(actions.entitiesListFailure(error));
  }
};

const handleCreateEntityRequest = function* ({ payload }) {
  try {
    const response = yield call(createEntity, payload);
    if (response.isAxiosError)
      return yield put(actions.createEntityFailure(response.response.data));
    yield put(actions.createEntitySuccess(response));
  } catch (error) {
    yield put(actions.createEntityFailure(error));
  }
};

const handleModifyEntityRequest = function* ({ payload }) {
  try {
    const response = yield call(modifyEntity, { ...payload });
    if (response.isAxiosError)
      return yield put(actions.modifyEntityFailure(response.response.data));
    yield put(actions.modifyEntitySuccess(response));
  } catch (error) {
    yield put(actions.modifyEntityFailure(error));
  }
};

const handleDeleteEntityRequest = function* ({ payload: { id } }) {
  try {
    const response = yield call(deleteEntity, id);
    if (response.isAxiosError)
      return yield put(actions.deleteEntityFailure(response.response.data));
    yield put(actions.deleteEntitySuccess(response));
  } catch (error) {
    yield put(actions.deleteEntityFailure(error));
  }
};

export default all([
  takeLatest(types.ENTITIES_LIST_REQUEST, handleEntitiesListRequest),
  takeEvery(types.CREATE_ENTITY_REQUEST, handleCreateEntityRequest),
  takeEvery(types.MODIFY_ENTITY_REQUEST, handleModifyEntityRequest),
  takeEvery(types.DELETE_ENTITY_REQUEST, handleDeleteEntityRequest),
  takeLatest(actions.getSelectedEntityRequest.type, handleRequest),
]);
